export const ACTION_TYPES = ["action", "dialogue", "inner_thought", "transition"];
export const ACTION_TYPE_SET = new Set(ACTION_TYPES);
export const NON_ACTOR_SPEAKER_KINDS = ["system", "broadcast", "offscreen", "group"];
export const NON_ACTOR_SPEAKER_KIND_SET = new Set(NON_ACTOR_SPEAKER_KINDS);
export const IMPORTANCE_TIERS = ["featured", "background"];
export const IMPORTANCE_TIER_SET = new Set(IMPORTANCE_TIERS);
export const ROLE_TYPES = ["主角", "配角"];
export const ROLE_TYPE_SET = new Set(ROLE_TYPES);
// Scene time is part of the schema's closed vocabulary, not an ingest concern;
// the alias table that maps free text onto these values stays in ingest.
export const SCENE_TIME_VALUES = ["day", "night", "dawn", "dusk"];
export const SCENE_TIME_SET = new Set(SCENE_TIME_VALUES);
export function isSceneTime(value) {
    return typeof value === "string" && SCENE_TIME_SET.has(value);
}
export const SCENE_SPACE_VALUES = ["interior", "exterior"];
export const SCENE_SPACE_SET = new Set(SCENE_SPACE_VALUES);
